<script setup lang="ts">
export interface Props {
  isMini?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  isMini: false,
});

const portalVersion = __APP_VERSION__;
</script>

<template>
  <div
    :class="[
      $style.sideMainBarPortalVersionText,
      { [$style.isMini]: props.isMini },
    ]"
    data-testid="sideMainBarPortalVersionText"
  >
    <template v-if="props.isMini">v{{ portalVersion }}</template>
    <template v-else>Portal version: {{ portalVersion }}</template>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.sideMainBarPortalVersionText {
  color: colors.$color-text-tertiary;
  font-size: 10px;
  display: flex;
  justify-content: normal;
  padding-left: 22px;
  padding-top: 8px;
  white-space: nowrap;

  &.isMini {
    justify-content: center;
    padding-left: 0px;
    text-align: center;
  }
}
</style>
